import React from 'react'
import ReactQuill from 'react-quill'
import { red500, grey500 } from 'material-ui/styles/colors'

const theme = 'snow'
const styles = {
  container: {
    marginTop: '1em',
    marginBottom: '1em'
  },
  label: {
    color: grey500
  },
  errorText: {
    borderTop: `1px solid ${red500}`,
    paddingTop: '5px',
    color: red500,
    fontSize: '12px',
    lineHeight: '12px'
  }
}

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    ['link', 'image', 'video'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ size: ['small', false, 'large', 'huge'] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ['clean']
  ],
  clipboard: {
    // See: https://github.com/zenoamaro/react-quill/issues/250
    matchVisual: false
  }
}

const Wysiwyg = props => {
  const { label, errorText, ...forwardProps } = props
  return (
    <div style={styles.container}>
      <label style={styles.label}>{label}</label>
      <ReactQuill theme={theme} modules={modules} {...forwardProps} />
      {errorText && <div style={styles.errorText}>{errorText}</div>}
    </div>
  )
}

export default Wysiwyg
